import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import it from './locales/it.json';
import es from './locales/es.json';
import de from './locales/de.json';
import fr from './locales/fr.json';
import pt from './locales/pt.json';
import ja from './locales/ja.json';
import zh from './locales/zh.json';
import nl from './locales/nl.json';
import pl from './locales/pl.json';
import ru from './locales/ru.json';
import hi from './locales/hi.json';

const resources = {
  en: { translation: en },
  it: { translation: it },
  es: { translation: es },
  de: { translation: de },
  fr: { translation: fr },
  pt: { translation: pt },
  ja: { translation: ja },
  zh: { translation: zh },
  nl: { translation: nl },
  pl: { translation: pl },
  ru: { translation: ru },
  hi: { translation: hi }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: Object.keys(resources),
    // "it-IT", "pt-BR"... from the browser map to the base language we ship.
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

const applyLang = (lng) => {
  try {
    document.documentElement.lang = (lng || 'en').split('-')[0];
    document.dir = 'ltr';
  } catch { /* ignore */ }
};

applyLang(i18n.resolvedLanguage || i18n.language);
i18n.on('languageChanged', applyLang);

export default i18n;
